module.exports = __webpack_public_path__ + "c9abea4bb97e8f6d5d473909bc74046c.svg";